import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalModificarSmtpCredential = ({ isOpen, toggle, selectedSmtpCredential, onSave }) => {
    const [formData, setFormData] = useState({
        id: '',
        usuario: '',
        password: '',
        smtp_host: '',
        port: '',
    });

    useEffect(() => {
        if (selectedSmtpCredential) {
            setFormData({
                id: selectedSmtpCredential.id || '',
                usuario: selectedSmtpCredential.usuario || '',
                password: selectedSmtpCredential.password || '',
                smtp_host: selectedSmtpCredential.smtp_host || '',
                port: selectedSmtpCredential.port || '',
            });
        }
    }, [selectedSmtpCredential]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        // Filter out empty fields - only send non-empty values
        const updateData = {};
        if (formData.usuario && formData.usuario.trim() !== '') {
            updateData.usuario = formData.usuario.trim();
        }
        if (formData.password && formData.password !== '') {
            updateData.password = formData.password;
        }
        if (formData.smtp_host && formData.smtp_host.trim() !== '') {
            updateData.smtp_host = formData.smtp_host.trim();
        }
        if (formData.port && formData.port !== '') {
            updateData.port = parseInt(formData.port);
        }

        // Validate at least one field is being updated
        if (Object.keys(updateData).length === 0) {
            alert('Por favor, ingrese al menos un campo para actualizar');
            return;
        }

        onSave(updateData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Credencial SMTP</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="id">ID</Label>
                        <Input
                            type="text"
                            name="id"
                            id="id"
                            value={formData.id}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="usuario">Usuario</Label>
                        <Input
                            type="text"
                            name="usuario"
                            id="usuario"
                            value={formData.usuario}
                            onChange={handleChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="password">Contraseña</Label>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="smtp_host">Host SMTP</Label>
                        <Input
                            type="text"
                            name="smtp_host"
                            id="smtp_host"
                            value={formData.smtp_host}
                            onChange={handleChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="port">Puerto</Label>
                        <Input
                            type="number"
                            name="port"
                            id="port"
                            value={formData.port}
                            onChange={handleChange}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarSmtpCredential;